import {toast} from "vue3-toastify";
import {i18n} from "./../lang";
import {aiDebuggerService} from "@/services/aiDebuggerService";
import {pushService} from "@/services/pushService";

const PUSH_TYPE = "AI_DEBUGGER_REQUESTS_UPDATED";
const FINISHED = ["COMPLETED", "FAILED"];

let unsubscribe = null;

const state = {
    investigations: [],
    isPanelOpen: false,
    unseenIds: [],
    getInvestigationsRequest: {
        loading: false
    },
    createInvestigationRequest: {
        loading: false
    }
}

const mutations = {
    setInvestigations(state, investigations) {
        state.investigations = investigations;
    },
    setIsPanelOpen(state, isOpen) {
        state.isPanelOpen = isOpen;
        if (isOpen) state.unseenIds = [];
    },
    addUnseenIds(state, ids) {
        state.unseenIds = [...new Set([...state.unseenIds, ...ids])];
    },
    setGetInvestigationsRequest(state, {loading, message}) {
        state.getInvestigationsRequest = {loading, message};
    },
    setCreateInvestigationRequest(state, {loading, message}) {
        state.createInvestigationRequest = {loading, message};
    }
}

const actions = {
    getInvestigations({commit, state}) {
        commit('setGetInvestigationsRequest', {loading: true});
        return aiDebuggerService.getInvestigations()
            .then((response) => {
                const investigations = response.data || [];
                const justFinished = investigations
                    .filter((investigation) => FINISHED.includes(investigation.status))
                    .filter((investigation) => state.investigations.some((previous) =>
                        previous.requestId === investigation.requestId && !FINISHED.includes(previous.status)
                    ))
                    .map((investigation) => investigation.requestId);
                if (justFinished.length && !state.isPanelOpen) commit('addUnseenIds', justFinished);
                commit('setInvestigations', investigations);
                commit('setGetInvestigationsRequest', {loading: false});
            })
            .catch((error) => {
                commit('setGetInvestigationsRequest', {loading: false, message: error});
            });
    },
    createInvestigation({commit, dispatch}, request) {
        commit('setCreateInvestigationRequest', {loading: true});
        return aiDebuggerService.createInvestigation(request)
            .then(() => {
                toast.success(i18n.global.t("aiDebugger.investigationStarted"));
                commit('setCreateInvestigationRequest', {loading: false});
                dispatch('getInvestigations');
                return true;
            })
            .catch((error) => {
                toast.error(typeof error === "string" && error ? error : i18n.global.t("toast.createError"));
                commit('setCreateInvestigationRequest', {loading: false, message: error});
                return false;
            });
    },
    watchInvestigations({dispatch}) {
        if (unsubscribe) return;
        unsubscribe = pushService.subscribe(PUSH_TYPE, () => dispatch('getInvestigations'));
        dispatch('getInvestigations');
    },
    unwatchInvestigations() {
        if (!unsubscribe) return;
        unsubscribe();
        unsubscribe = null;
    }
}

export const aiDebugger = {
    namespaced: true,
    state,
    mutations,
    actions
}
